module.exports = __webpack_public_path__ + "img/preview-3.d173670b.webp";